import React from "react";
import {
  Badge,
} from "@chakra-ui/react";

import { CrudPage } from "../components/CrudPage";
import { PaymentBatchCardForm } from "../components/forms/PaymentBatchCardForm";
import { clubRewardsAdmin } from "../services/api";

const formatNumber = (value?: number) =>
  Number(value || 0).toLocaleString("fa-IR");

const formatDate = (value?: string) =>
  value ? new Date(value).toLocaleDateString("fa-IR") : "—";

const statusMeta: Record<string, { label: string; colorScheme: string }> = {
  active: { label: "فعال", colorScheme: "green" },
  inactive: { label: "غیرفعال", colorScheme: "gray" },
};

const columns = [
  {
    header: "هزینه امتیاز",
    accessor: "pointsCost",
    render: (item: any) => formatNumber(item.pointsCost),
  },
  {
    header: "مبلغ کارت هدیه",
    accessor: "paymentBatch.amount",
    render: (item: any) => formatNumber(item?.paymentBatch?.amount),
  },
  {
    header: "صندوق",
    accessor: "paymentBatch.fundName",
    render: (item: any) => item?.paymentBatch?.fundName || "—",
  },
  {
    header: "شناسه صندوق",
    accessor: "paymentBatch.fundSeoRegisterNo",
    render: (item: any) => item?.paymentBatch?.fundSeoRegisterNo || "—",
  },
  {
    header: "انقضا",
    accessor: "paymentBatch.expiresAt",
    render: (item: any) => formatDate(item?.paymentBatch?.expiresAt),
  },
  {
    header: "وضعیت",
    accessor: "status",
    render: (item: any) => {
      const meta = statusMeta[item.status] || statusMeta.inactive;
      return <Badge colorScheme={meta.colorScheme}>{meta.label}</Badge>;
    },
  },
  {
    header: "تاریخ ایجاد",
    accessor: "createdAt",
    render: (item: any) => formatDate(item.createdAt),
  },
];

export const ClubRewardsPage: React.FC = () => {
  return (
    <CrudPage
      title="مدیریت جوایز باشگاه"
      columns={columns}
      queryKey="club-admin-rewards"
      dataKey="rewards"
      resourceName="clubRewards"
      api={clubRewardsAdmin}
      FormComponent={({ initialData, onSubmit, onCancel }) => (
        <PaymentBatchCardForm
          mode="single"
          initialData={initialData}
          includeClubRewardFields
          showTitleDescriptionFields={false}
          onSubmit={onSubmit}
          onCancel={onCancel}
        />
      )}
    />
  );
};
